import Loader from '../Loader';

type FullpageLoaderProps = {
  isVisible?: boolean;
};
const FullPageLoader = ({ isVisible = true }: FullpageLoaderProps) => {
  if (!isVisible) return null;
  return <Loader overlayViewMode="fullscreen" active viewMode="fluid" />;
};

export default FullPageLoader;
